// Allows callers outside the React tree (e.g. context-switch mutations) to
// suppress the beforeunload prompt for a single intentional page navigation.
let skipNextBeforeUnload = false

export function skipNavigationPromptOnce() {
  skipNextBeforeUnload = true
}

export function consumeSkipNavigationPrompt(): boolean {
  if (skipNextBeforeUnload) {
    skipNextBeforeUnload = false
    return true
  }
  return false
}
